<script lang="ts">
    import type {Conversation} from './types';
    import {mySession} from './services';
    import OperatorName from './OperatorName.svelte';

    export let conversation: Conversation;

    let writeOperator;
    let writeClient;
    $: {
        writeOperator = !!conversation.operator
        writeClient = conversation.client.id !== $mySession.id;
    }
</script>

<span>
	{#if writeOperator}
		<OperatorName session={conversation.operator} />
	{/if}
    {#if writeOperator && writeClient}
		-
	{/if}
    {#if writeClient}
		{conversation.client.username}
	{/if}
</span>
